import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function ConfirmationModal({ show, handleCancel, handleConfirm, message, title, confirmText = 'Confirm', cancelText = 'Cancel' }) {
  return (
    <Modal
      show={show}
      onHide={handleCancel}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>{cancelText}</Button>
        <Button variant="danger" onClick={handleConfirm}>{confirmText}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmationModal;

